module.exports = __webpack_public_path__ + "static/media/obey.b7d9283c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/obey.mp3
// module id = 514
// module chunks = 0